import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_e185b7e9 from '../styles/Skeleton.module.less.js';

/**
 * @description Skeleton Button component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Button />
 * ```
 */
const Button = (props) => {
    const { block, className, inverted = false, ...restProps } = props;
    const cx = useStyles(modules_e185b7e9);
    const classNames = cx(className, 'button', { block, inverted });
    return React.createElement("div", { className: classNames, ...restProps });
};
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=Button.js.map
